import React from 'react';
import LogoImg from '../../../../assets/images/logos/logo.png'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import './Logo.scss';

export const Logo = () => {
    return (
        <div className="logo">
            <Link
                to='/'
            >
                <img src={LogoImg} alt="" />
            </Link>
        </div>
    )
}